import { makeActionCreator } from '../../../utilities'
import { CommentsConstants } from './comments.constants'

export const setCommentPageTitle = makeActionCreator(CommentsConstants.SET_COMMENT_PAGE_TITLE, 'commentPageTitle')

export const setCommentText = makeActionCreator(CommentsConstants.SET_COMMENT_TEXT, 'commentText')

export const setCommentMaxLength = makeActionCreator(CommentsConstants.SET_COMMENT_MAX_LENGTH, 'commentMaxLength')

export const setPreviousPagePath = makeActionCreator(CommentsConstants.SET_PREVIOUS_PAGE_PATH, 'previousPagePath')

export const setOnChangeAction = makeActionCreator(CommentsConstants.SET_ON_CHANGE_ACTION, 'onChangeAction')

export const setSaveAction = makeActionCreator(CommentsConstants.SET_SAVE_ACTION, 'saveAction')

export const resetCommentsState = makeActionCreator(CommentsConstants.RESET_COMMENTS_STATE)

export const setHideComments = makeActionCreator(CommentsConstants.HIDE_COMMENTS, 'hideComments')
